// extracted by mini-css-extract-plugin
export default {"container":"initiative-card_container__POOPA"};